<template>
<div class="cont">
  <div id="login" class="login" data-role="page">
    <div class="hd tx-c">
        <h2>合同管理系统</h2>
    </div>
    <div class="bd">
      <input type="hidden" id="wxid" name="wx_id" value="${wxid!}">
      <input type="hidden" id="referer" value="${referer!}">
      <div class="weui_cells weui_cells_access">
          <div class="weui_cell login_box_line">
              <div class="weui_cell_bd weui_cell_primary">
                  <p><input type="text" class="input_name" v-model.trim='username' placeholder="请输入用户名"/></p>
              </div>
          </div>
          <div class="weui_cell login_box_line">
              <div class="weui_cell_bd weui_cell_primary">
                  <p><input type="password" class="input_name" v-model.trim='password' placeholder="请输入密码" /></p>
              </div>
          </div>
      </div>
      <div class="btn_log">
         <button  v-bind:class="[{'weui-btn_disabled': false}, 'weui-btn weui-btn_primary']" @click="loginaa">登录</button>
      </div>
      </div>
    </div>
    <div class="js_dialog" v-show="showtip">
      <div class="weui-mask"></div>
      <div class="weui-dialog">
        <div class="weui-dialog__hd"><strong class="weui-dialog__title">登陆出错</strong></div>
        <div class="weui-dialog__bd">{{tipContent}}</div>
        <div class="weui-dialog__ft">
            <a class="weui-dialog__btn weui-dialog__btn_primary" @click.prevent.stop="close">关闭</a>
        </div>
      </div>
    </div>
    <div class="list_loadingToast" v-show='showLoginLoading'>
      <div class="weui-mask_transparent"></div>
      <div class="weui-toast">
        <i class="weui-loading weui-icon_toast"></i>
        <p class="weui-toast__content">登录中...</p>
      </div>
    </div>
</div>
</template>
<script>
  // import { MessageBox } from 'vue-desktop'
  import { mapActions } from 'vuex'
  export default {
    data () {
      return {
        username: '',
        password: '',
        disabled_btn: true,
        wxid: 0,
        tipContent: '',
        showtip: false,
        showLoginLoading: false
      }
    },
    mounted: function () {
      this.type = this.$route.params.type
      this.wxid = this.$route.params.wxid
    },
    /* computed: {
      function () {
        let formvm = this
        window.alert('null')
        if (!formvm.username || !formvm.password) {
          window.alert('null')
        }
      }
    }, */
    methods: {
      ...mapActions([
        'clearpage'
      ]),
      check () {
        if (this.username.length > 0 && this.password.length > 0) {
          this.disabled_btn = false
        } else {
          this.disabled_btn = true
        }
      },
      loginaa () {
        let vm = this
        if (this.username.length > 0 && this.password.length > 0) {
          vm.showLoginLoading = true
          let thispage = {pageSize: 5, totalPage: 1, totalRow: 0, firstPage: true, lastPage: true, list: {}}
          vm.clearpage(thispage)
          this.$http.post('rest/user/login', {
            'username': this.username,
            'password': this.password,
            'wxid': this.wxid
          }).then(function (res) {
            vm.showLoginLoading = false
            if (res.data.ok) {
              if (vm.type > 0) {
                vm.$router.push({path: '/listSealOut/index', query: {showNavbar: true, showBack: false, selected: 0, refresh: true}})
              } else {
                vm.$router.push({path: '/list/index', query: {showNavbar: true, showBack: false, selected: 0, refresh: true}})
              }
            } else {
              vm.showtip = true
              vm.tipContent = res.data.msg
              vm.disabled_btn = true
            }
          })
        } else {
          if (this.username.length <= 0) {
            vm.showtip = true
            vm.tipContent = '用户名不能为空'
          } else if (this.password.length <= 0) {
            vm.showtip = true
            vm.tipContent = '密码不能为空'
          }
        }
      },
      close () {
        this.showtip = false
        // this.username = ''
        this.password = ''
      },
      submit () {
        console.log('sss')
      },
      sendMsg () {
        this.$http.post('rest/api/sendMessage').then(function (res) {
          if (res.data.ok) {
            window.alert('ok')
          }
        })
      }
    }
  }
</script>
<style>
/*登录*/
.login{
    /*height:100%;*/
    padding-top: 40px;
    -webkit-tap-highlight-color:transparent;
    background-color: #f1f1f1;
}
.login .hd{text-align: center;padding-top: 20px;}
.login .hd img{width: 60%;}
.login .bd{padding-top: 25px;}
.login .login_box_line{height: 50px;border-bottom: 1px #DEDEDE solid;margin: 0 15px;}
.login .input_name{width: 90%;border: none;height: 40px;line-height: 40px;font-size: 18px;}
.login .weui_cells:before,.login .weui_cell:before,.login .weui_cells:after{border: none;}
.login .weui_cell {padding: 10px 5px 0 5px;}
.login .weui_cell_ft:after {border-width: 0;}
.login .btn_log{margin:35px 15px;}
.login .login_floor1{margin:0 15px; color: #656565;}
.login .login_floor1 a{color: #656565;}
.login .weui_cells_access {background-color: #fff;}
</style>



// WEBPACK FOOTER //
// login.vue?27275f24